<template>
  <VueTypeaheadBootstrap
    v-model="search"
    @hit="input_value = $event"
    :data="tipos_concedentes"
    :serializer="(item) => item.nome"
    :placeholder="placeholder"
    :class="[stateClass]"
    class="form-select-typeahead"
    :showOnFocus="true"
    :size="size"
  >
    <template slot="append">
      <i class="fas fa-caret-down"></i>
    </template>
  </VueTypeaheadBootstrap>
</template>

<script>
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
import { mapActions } from "vuex";

import {
  formControlMixin,
  props as formControlProps,
} from "bootstrap-vue/src/mixins/form-control";

import {
  formStateMixin,
  props as formStateProps,
} from "bootstrap-vue/src/mixins/form-state";

import { sortKeys } from "bootstrap-vue/src/utils/object";
import { makePropsConfigurable } from "bootstrap-vue/src/utils/props";
import _ from "lodash";

const props = makePropsConfigurable(
  sortKeys({
    ...formStateProps,
    ...formControlProps,
    value: {},
    return_object: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "Selecione",
    },
    size: {
      type: String,
      default: "md",
    },
  })
);

export default {
  components: { VueTypeaheadBootstrap },
  mixins: [formControlMixin, formStateMixin],
  props,
  data: () => ({
    search: "",
    input_value: null,
    tipos_concedentes: [],
  }),
  computed: {},
  methods: {
    ...mapActions("tipos_concedentes", ["ActionFind"]),
    setById(id) {
      let selected = _.find(this.tipos_concedentes, { id: id });

      if (selected) {
        this.search = selected.nome;
        this.input_value = selected;
      }
    },
  },
  watch: {
    search: function (value) {
      if (value === "") {
        this.$emit("input", null);
      }
    },
    input_value() {
      if (this.return_object) {
        this.$emit("input", this.input_value);
      } else {
        this.$emit("input", this.input_value.id);
      }
    },
    value: function (id, old) {
      if (id != old) {
        this.setById(this.value);
      }
    },
  },
  async created() {
    let tipos_concedentes = await this.ActionFind();
    this.tipos_concedentes = tipos_concedentes.data;

    if (this.value) {
      this.setById(this.value);
    }
  },
};
</script>

<style lang="scss">
.form-select-typeahead {
  .input-group {
    .form-control {
      border-right: 1px solid #cad1d7 !important;
      border-radius: 0.375rem;
    }

    .input-group-append {
      position: absolute;
      padding-right: 10px;
      padding-top: 13px;
      background: transparent;
      height: 100%;
      right: 0;
    }
  }
}
</style>
